import { makeStyles } from '@material-ui/core/styles';
import { addMenu } from 'UI/constants/dimensions';

export const useStyles = makeStyles(theme => ({
  triggerButton: {
    backgroundColor: theme.palette.primary.fill,
    color: theme.palette.brandColors.FPWhite,
    fontSize: theme.typography.fontSizeLarge,
    fontWeight: theme.typography.fontWeightBold,
    height: addMenu.addButton.height
  }
}));
